<template>
  <div class="d-flex align-items-center">
    <b-pagination v-model="numPaginationPage"
                  :number-of-pages="pagination.num_pages"
                  :per-page="pagination.page_size"
                  :total-rows="pagination.total"
                  class="custom-pagination"
                  @page-click="onPageClick">
      <template #first-text>
        <Icon name="chevronLeftDouble" width="20"/>
      </template>
      <template #prev-text>
        <Icon name="chevronLeft" width="20"/>
      </template>
      <template #next-text>
        <Icon name="chevronRight" width="20"/>
      </template>
      <template #last-text>
        <Icon name="chevronRightDouble" width="20"/>
      </template>
    </b-pagination>
    <b-form-select
        class="select-pagination ml-1"
        v-model="numPaginationPage"
        :options="paginationOptions"
        @change="onPageSelect"
        size="sm"
    ></b-form-select>
  </div>
</template>
<script>
export default {
  name: "PaginationNumber",
  emits: ['page-change'],
  data() {
    return {
      numPaginationPage: 1,
    }
  },
  props: {
    pagination: {
      type: Object,
      required: true
    }
  },
  computed: {
    paginationOptions() {
      return Array.from({length: this.pagination.num_pages}, (v, k) => {
        return {text: k + 1, value: k + 1}
      })
    }
  },
  methods: {
    onPageSelect(event) {
      this.$emit('page-change', event)
    },
    onPageClick(event, page) {
      this.numPaginationPage = page
      this.$emit('page-change', page)
    }
  },
}
</script>


<style scoped>

</style>